import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const get_vip_bonus = createAsyncThunk(
  'bonusPlay/get_vip_bonus',
  async (arg: any, store: any) => {
    const resp = await http.post<any>(
      '/live/vip/get_vip_bonus',
      {...arg},
      {
        store, xcErrorToast: true
      }
    )
    return resp.data.data
  }
)

export const get_vip_bonus_card_status = createAsyncThunk(
  'bonusPlay/get_vip_bonus_card_status',
  async (arg: any, store: any) => {
    const resp = await http.post<any>(
      '/live/privilege/get_vip_bonus_card_status',
      {...arg},
      {
        store, xcErrorToast: true
      }
    )
    return resp.data.data
  }
)


export const use_vip_bonus_card = createAsyncThunk(
  'bonusPlay/use_vip_bonus_card',
  async (arg: any, store: any) => {
    const resp = await http.post<any>(
      '/live/privilege/use_vip_bonus_card',
      {...arg},
      {
        store, xcErrorToast: true
      }
    )
    return resp.data.data
  }
)

export const get_vip_bonus_card_list = createAsyncThunk(
  'bonusPlay/get_vip_bonus_card_list',
  async (arg: any, store: any) => {
    const resp = await http.post<any>(
      '/live/privilege/get_vip_bonus_card_list',
      {...arg},
      {
        store, xcErrorToast: true
      }
    )
    return resp.data.data?.list || []
  }
)

export interface InitialStateType {
  pageData: {
    ratio_list?: [number] // 加成倍数
    bonus_threshold?: number // 积分上限
    is_activity_doing?: boolean // 活动是否进行中
    has_bonus_buff?: boolean // 是否已经抽取加成
    my_bonus_buff?: number // 我的加成
    count_down?: number // 倒计时
  }
  cardInfo: any
  ratioList: Array<any>
}

const initialState: InitialStateType = {
  pageData: {},
  cardInfo: {},
  ratioList: [],
}

export const VipBounsSlice = createSlice({
  name: 'VipBounsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_vip_bonus.fulfilled, (state, action) => {
      Object.assign(state.pageData, action.payload)
    })
    builder.addCase(get_vip_bonus_card_status.fulfilled, (state, action) => {
      Object.assign(state.cardInfo, action.payload)
    })
    builder.addCase(get_vip_bonus_card_list.fulfilled, (state, action) => {
      Object.assign(state.ratioList, action.payload)
    })
  },
})
export default VipBounsSlice.reducer
export const VipBounsActions = VipBounsSlice.actions

export const useVipBounsState = () => {
  const data = useSelector((state) => {
    return state.Animal_Elk
  })
  return data
}
